/**
 * Ink values for the printed PDFs (readiness record, funding request).
 * They are the light theme's own hex codes (src/theme/colors.ts),
 * hand-copied rather than imported: the documents never mount inside a
 * ThemeProvider, and a printed page is always light-mode regardless of
 * which theme the screen was in when the button was pressed (see the
 * PRINT_CSS comment in app/structure/report/[id].tsx for why). The rung is
 * the only color the record spends: everything else is ink and hairlines.
 */
export const INK = '#161615';
export const INK_SECONDARY = '#6d6d6a';
export const INK_TERTIARY = '#9d9d99';
export const HAIRLINE = '#ececea';
export const DOCUMENTED = '#2d6a4f';
export const OPEN = '#9d9d99';
/** The page itself, used as a halo behind map lines and labels. */
export const PAPER = '#ffffff';
